<template>
<div style="width:100%">
  <van-collapse v-model="activeNames">
    <van-collapse-item title="发票信息" name="1">
      <van-field v-model="inputForm.invoiceDetail.purchaser_name" label="购买方名称" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.purchaser_register_num" label="购买方税号" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.saler" label="销售方名称" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.saler_tax_num" label="销售方税号" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.invoice_date" label="开票日期" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.invoice_code" label="发票代码" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.invoice_num" label="发票号码" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.printed_code" label="机打代码" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.car_class" label="车辆类型" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.car_model" label="厂牌型号" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.product_location" label="产地" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.certificate_num" label="合格证号" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.engine_num" label="发动机号码" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.vin_num" label="车架号码" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.tax_rate" label="税率（%）" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.tax" label="税额（元）" :formatter="formatter" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.price" label="不含税价格（元）" :formatter="formatter" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.price_tax_big" label="价税合计大写" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.price_tax_small" label="价税合计小写" :formatter="formatter" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.saler_phone" label="销货单位电话" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.saler_bank_num" label="销货单位账号" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.saler_address" label="销货单位地址" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.saler_bank" label="销货单位开户银行" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.tax_jiguan" label="主管税务机关" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.tax_jiguan_code" label="主管税务机关代码" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.limit_mount" label="限乘人数" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.toonage" label="吨位" label-width="120px"
                 readonly input-align="left" :border="false" />

<!--      <div style="padding-left: 16px;" v-show="inputForm.invoiceDetail.attachList&&inputForm.invoiceDetail.attachList.length > 0">-->
<!--        <p>附件</p>-->
<!--        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.invoiceDetail.attachList" :key="index"-->
<!--           @click="$viewAttach(file)">{{ file.name }}</p>-->
<!--      </div>-->
    </van-collapse-item>
<!--    <van-collapse-item title="业务信息" name="3">-->

<!--      <div style="padding-left: 16px;" v-show="inputForm.invoiceDetail.attachList&&inputForm.invoiceDetail.attachList.length > 0">-->
<!--        <p>附件</p>-->
<!--        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.invoiceDetail.attachList" :key="index"-->
<!--           @click="$viewAttach(file)">{{ file.name }}</p>-->
<!--      </div>-->
<!--    </van-collapse-item>-->
  </van-collapse>
</div>
</template>

<script>
export default {
  name: "vehicleInvoiceFlowForm",
  data(){
    return {
      inputForm:{
        invoiceDetail:{}
      },
      activeNames: ['1', '2']
    }
  },
  methods: {
    init(data){
      this.inputForm = data
    },
    formatter(value){
      return Number(value).toFixed(2)
    }
  }
}
</script>

<style scoped>

</style>